/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalDetailsDescription_goal = {
    readonly id: string;
    readonly description: string | null;
    readonly " $refType": "GoalDetailsDescription_goal";
};
export type GoalDetailsDescription_goal$data = GoalDetailsDescription_goal;
export type GoalDetailsDescription_goal$key = {
    readonly " $data"?: GoalDetailsDescription_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsDescription_goal">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoalDetailsDescription_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
(node as any).hash = '4febf0cbdb51a93e6b3f563cb61e1c23';
export default node;
